import * as Sentry from '@sentry/react';
import type { IError } from './types/common';

export const getWindowSessionReplayURL = (): string | null => {
  // Enhanced safety checks for headless mode and incomplete BrightWrite client initialization
  if (
    typeof window === 'undefined' ||
    window.isHeadless ||
    !window.bwClient ||
    !window.bwClient.sentry ||
    typeof window.bwClient.getSessionReplayURL !== 'function'
  ) {
    return null;
  }

  try {
    return window.bwClient.getSessionReplayURL();
  } catch (error) {
    // Fallback for any runtime errors during BrightWrite client access
    console.warn('Failed to get BrightWrite session replay URL:', error);
    return null;
  }
};

export function captureExceptionWithRecording(
  error: IError,
  extra?: Record<string, any>,
): void {
  if (!window.isHeadless && window.bwtag) {
    Sentry.setTag('BW Session', getWindowSessionReplayURL() ?? 'BW Not Ready');
  }

  if (error.status) {
    Sentry.setTag('error_status', error.status);
  }
  if (error.code) {
    Sentry.setTag('error_code', error.code);
  }
  if (error.requestId) {
    Sentry.setTag('x-request-id', error.requestId);
  }
  if (extra?.url) {
    Sentry.setTag('api_url', extra.url);
  }

  Sentry.captureException(
    error,
    extra && {
      extra,
    },
  );
}
